import { useWorkflowOptional } from "./WorkflowContext";
import { supersedePlan } from "./supersedePlan";
import { supersedeCalc, supersedeCalcAsync, routeTxnsManualOverrideAsync } from "../lib/api";

/**
 * A1-93 review round 2 (R2-2) — the ONE way the screens replace a calc.
 *
 * Every action that supersedes (Step 6 "Supersede this filing", the
 * Inspect drawer's "drop rows", the manual-box route) used to re-run on
 * the OLD calc's exchange rates; opening the replacement then wrote those
 * back over a rate the operator had just corrected — silently. Each now
 * goes through here: when the calc being replaced is the one open in the
 * workflow and the form no longer matches it, the form's rates and
 * country filter travel with the request, and a change a supersede cannot
 * honour (files, period, client, an invalid or emptied rate) refuses it
 * with the reason. For any other calc nothing on the form relates to it,
 * so it is replaced as before.
 */
const NONE = { blocked: null, overrides: {}, carries: false };

export const guardSupersede = (calcId, wf) => {
  const applies = !!calcId && wf?.calc?.id === calcId;
  const plan = applies
    ? supersedePlan(wf.state, { calc: wf.calc, periodFxRates: wf.periodFxRates,
      monthlyFxRates: wf.monthlyFxRates, countryFilter: wf.countryFilter })
    : NONE;
  const guard = (fn) => (body, ...rest) => {
    if (plan.blocked) {
      const e = new Error(plan.blocked);
      e.code = "SUPERSEDE_BLOCKED";
      return Promise.reject(e);
    }
    return fn(calcId, { ...body, ...plan.overrides }, ...rest);
  };
  return {
    plan,
    supersede: guard(supersedeCalc),
    supersedeAsync: guard(supersedeCalcAsync),
    routeManualOverrideAsync: guard(routeTxnsManualOverrideAsync),
  };
};

// For screens that may render outside the workflow provider.
export const useGuardedSupersede = (calcId) => guardSupersede(calcId, useWorkflowOptional());
